<template>
  <div>
      <ModalCadastroCategoria
                        ref="modalCadastroCategoria"
                        :categoriaEdicao="categoria"
                        @categoriaSalva="limparSelecionados" />

      <ModalCadastroDisciplina
                        ref="modalCadastroDisciplina"
                        :disciplinaEdicao="disciplina"
                        :categorias="categoriasEditaveis"
                        @disciplinaSalva="limparSelecionados" />

      <ModalCadastroSistema
                        ref="modalCadastroSistema"
                        :sistemaEdicao="sistema"
                        :categorias="categoriasEditaveis"
                        @sistemaSalva="limparSelecionados" />

    <div class="sub-menu"><span>Cadastrar/Editar Classificaçoes de Curso</span></div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="categoria">Categorias</label>
          <multiselect
            v-model="selectedCategoria"
            :options="categoriasEditaveis"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :show-labels="false"
            :preselect-first="true"
            placeholder="Selecionar"
            label="categoria"
            track-by="categoria"
            :block-keys="['Tab','Enter']"
          >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">
                    <i v-if="props.option.id == 0" class="fas fa-plus"></i>
                    <i v-else class="fas fa-edit"></i>
                    {{ props.option.categoria }}
                  </span>
                </div>
              </template>
          </multiselect>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="row">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="categoria">Disciplinas</label>
              <multiselect
                v-model="selectedDisciplina"
                :options="disciplinasEditaveis"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :show-labels="false"
                :preselect-first="true"
                placeholder="Selecionar"
                label="disciplina"
                track-by="disciplina"
                :block-keys="['Tab','Enter']"
              >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">
                        <i v-if="props.option.id == 0" class="fas fa-plus"></i>
                        <i v-else class="fas fa-edit"></i>
                        {{ props.option.disciplina }}
                      </span>
                    </div>
                  </template>
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="categoria">Sistemas</label>
              <multiselect
                v-model="selectedSistema"
                :options="sistemasEditaveis"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :show-labels="false"
                :preselect-first="true"
                placeholder="Selecionar"
                label="sistema"
                track-by="sistema"
                :block-keys="['Tab','Enter']"
              >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">
                        <i v-if="props.option.id == 0" class="fas fa-plus"></i>
                        <i v-else class="fas fa-edit"></i>
                        {{ props.option.sistema }}
                      </span>
                    </div>
                  </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoriaCursosAPI from '@/api/categorias-cursos-api'
import DisciplinaAPI from '@/api/disciplina-api'
import SistemaAPI from '@/api/sistema-api'
import ModalCadastroCategoria from '@/modules/Admin/components/ModalCadastroCategoria'
import ModalCadastroDisciplina from '@/modules/Admin/components/ModalCadastroDisciplina'
import ModalCadastroSistema from '@/modules/Admin/components/ModalCadastroSistema'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'CursosClassificacoes',
  components: { ModalCadastroCategoria, ModalCadastroDisciplina, ModalCadastroSistema, Multiselect },
  data () {
    return {
      categorias: [],
      selectedCategoria: false,
      categoria: {},
      disciplinas: [],
      selectedDisciplina: false,
      disciplina: {},
      sistemas: [],
      selectedSistema: false,
      sistema: {}
    }
  },
  watch: {
    selectedCategoria: function (value) {
      if (value) {
        if (value.id === 0) {
          this.categoria = {}
          this.$nextTick(() => {
            this.$refs.modalCadastroCategoria.show()
          })
        } else if (value.editavel === 1) {
          this.categoria = this.selectedCategoria
          this.$nextTick(() => {
            this.$refs.modalCadastroCategoria.show()
          })
        }
        this.selectedCategoria = false
      }
    },
    selectedDisciplina: function (value) {
      if (value) {
        if (value.id === 0) {
          this.disciplina = {}
          this.$nextTick(() => {
            this.$refs.modalCadastroDisciplina.show()
          })
        } else if (value.editavel === 1) {
          this.disciplina = this.selectedDisciplina
          this.$nextTick(() => {
            this.$refs.modalCadastroDisciplina.show()
          })
        }
        this.selectedDisciplina = false
      }
    },
    selectedSistema: function (value) {
      if (value) {
        if (value.id === 0) {
          this.sistema = {}
          this.$nextTick(() => {
            this.$refs.modalCadastroSistema.show()
          })
        } else if (value.editavel === 1) {
          this.sistema = this.selectedSistema
          this.$nextTick(() => {
            this.$refs.modalCadastroSistema.show()
          })
        }
        this.selectedSistema = false
      }
    }
  },
  computed: {
    categoriasEditaveis: function () {
      return this.categorias.filter(cat => cat.editavel === 1 || cat.id === 0)
    },
    disciplinasEditaveis: function () {
      return this.disciplinas.filter(dis => dis.editavel === 1 || dis.id === 0)
    },
    sistemasEditaveis: function () {
      return this.sistemas.filter(sis => sis.editavel === 1 || sis.id === 0)
    }
  },
  mounted () {
    this.carregaInfos()
  },
  methods: {
    carregaInfos: function () {
      CategoriaCursosAPI.listarCategorias().then(data => {
        this.categorias = data
        this.categorias.unshift({
          id: 0,
          categoria: 'Cadastrar nova categoria'
        })
      })
      DisciplinaAPI.listarDisciplinas().then(data => {
        this.disciplinas = data
        this.disciplinas.unshift({
          id: 0,
          disciplina: 'Cadastrar nova disciplina'
        })
      })
      SistemaAPI.listarSistemas().then(data => {
        this.sistemas = data
        this.sistemas.unshift({
          id: 0,
          sistema: 'Cadastrar novo Sistema'
        })
      })
    },
    limparSelecionados: function () {
      this.selectedCategoria = false
      this.categoria = {}
      this.selectedDisciplina = false
      this.disciplina = {}
      this.selectedSistema = false
      this.sistema = {}
      this.carregaInfos()
    }
  }
}
</script>
